import {LayoutType} from '@wandb/weave/common/types/media';
import {produce} from 'immer';
import _, {get, setWith} from 'lodash';

import {AllMaskControls, MaskControl} from '../../../components/MediaCard';
import {
  DEFAULT_ALL_MASK_CONTROL,
  DEFAULT_CLASS_MASK_CONTROL,
} from '../../../util/mediaConstants';
import {maskOptionsForLayout} from '../Component';
import * as PANEL_MEDIA_BROWSER_CONFIG from '../config';

export const defaultLayout = (maskKeys: string[]) => {
  return {
    type: PANEL_MEDIA_BROWSER_CONFIG.DEFAULT_LAYOUT_TYPE as LayoutType,
    maskOptions: maskOptionsForLayout(
      PANEL_MEDIA_BROWSER_CONFIG.DEFAULT_LAYOUT_TYPE,
      maskKeys
    ),
  };
};

export function getDefaultMaskControl(
  maskConfigPath: Array<string>
): MaskControl | null {
  if (maskConfigPath.length < 4) {
    // default only applies to class masks
    // short circuit for cleanup
    return null;
  }
  const classID = maskConfigPath[maskConfigPath.length - 1];
  return classID === 'all'
    ? DEFAULT_ALL_MASK_CONTROL
    : DEFAULT_CLASS_MASK_CONTROL;
}

export function getMaskControl(
  maskConfig: AllMaskControls,
  maskConfigPath: Array<string>
): MaskControl {
  return (
    get(maskConfig, maskConfigPath) ?? getDefaultMaskControl(maskConfigPath)
  );
}

export function cleanupMaskControl(
  maskConfig: AllMaskControls,
  maskConfigPath: Array<string>
): AllMaskControls {
  if (_.isEmpty(maskConfigPath)) {
    return maskConfig;
  }
  const maskControl = getMaskControl(maskConfig, maskConfigPath);
  if (
    _.isEmpty(maskControl) ||
    _.isEqual(maskControl, getDefaultMaskControl(maskConfigPath))
  ) {
    return cleanupMaskControl(
      _.omit(maskConfig, maskConfigPath.join('.')),
      maskConfigPath.slice(0, -1)
    );
  }
  return maskConfig;
}

export function buildMaskControl(
  newControl: Partial<MaskControl>,
  maskConfig: AllMaskControls,
  maskConfigPath: Array<string>
): AllMaskControls {
  const maskControl = getMaskControl(maskConfig, maskConfigPath);
  const newMaskConfig = produce(maskConfig, draft => {
    return setWith(
      draft,
      maskConfigPath,
      {...maskControl, ...newControl},
      Object
    );
  });
  return cleanupMaskControl(newMaskConfig, maskConfigPath);
}
